<template>
    <div class="flex justify-center">
        <div class="flex flex-col items-center justify-center gap-4" v-if="paperListIns.loading">
            <CatLoading  />
        </div>

        <div v-else-if="paperListIns.isEmpty" class="flex flex-col items-center justify-center">

            <CatHole2 class="mb-2 h-[50px] w-[70px]"/>
            <span class="text-sm text-grey-90">
                {{ t('noData') }}
            </span>
        </div>

        <div v-else class="flex w-full flex-col gap-4 pb-4" >

            <div class="flex items-center gap-2">
                <span class="flex items-center gap-1" v-html="t('totalPapers',{total: paperListIns.total})"></span>
                <a v-if="srpLink" class="th-btn th-btn-text px-0" :href="srpLink" target="_blank">{{ t('viewAll') }}</a>
            </div>

            <SolutionCard :with-border="true" :order="index + 1" :solution="item"
                          v-for="(item, index) in paperListIns.list" :key="item.SOLUTION_ID" >
                <template #customContent>
                    <SolutionCardOfPaper :item="item" />
                </template>
            </SolutionCard>

            <div  class="mx-auto" v-if="paperListIns.hasNext">
                <span v-if="paperListIns.moreLoading" class="th-loading th-loading-spinner th-loading-md"></span>
                <button v-else class="th-btn" @click="handleMore">{{ t('viewMore') }}</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { SolutionCard } from '@eureka/solution-card';
import { CatLoading, CatHole2 } from '@eureka/cat'
import { useI18n } from 'vue-i18n';
import { PaperListService } from '@/services/paper-list-service';
import { Site, SLD } from '@patsnap-utils/biz';
import { SOLUTION_TYPE } from '@eureka/solution-card/src/types';
import SolutionCardOfPaper from '@/components/SolutionCardOfPaper.vue'
import { useGlobalState } from '@/composables/use-global-store';
import '@patsnap-ui/icon/assets/solid/info.svg'
import { controlDeferred } from '@eureka/utils/control';
import { CommonApis } from '@eureka/services/src/apis/common.api';
import { generateSimpleQuery } from '@eureka/utils/block-to-query';
import { Playbooks } from '@eureka/services/src/types/playbook';
import { useCompanyBasic } from '@/composables/use-company-basic';
import { ESearchField } from '@/types';
import { hookErrorCode } from '@eureka/services/src/custom-error-handler';
import { LIMITED_PERMISSION_CODE } from '@/constant';

const { companyId, checkedChild, updateLimitInfo } = useGlobalState()
const { t } = useI18n()
const { companyInfo } = useCompanyBasic()

const paperListIns = ref(new PaperListService())
const srpLink = ref('')

const basicParams = computed(() => ({
    entity_id: companyId.value,
    solution_type: SOLUTION_TYPE.PAPER,
    include_children: false,
}))

function handleMore() {
    paperListIns.value.loadMore(basicParams.value)
}

async function generateQId(companyName: string) {
    const { isMaterial } = await controlDeferred.promise
    const { qid } = await CommonApis.queryItemToShort({
        q_s: generateSimpleQuery(ESearchField.ONE_ID, {
            name: companyName,
            value: companyId.value,
        }),
    });
    const playbook = isMaterial ? Playbooks.LITERATUREMATERIAL : Playbooks.LITERATURE
    srpLink.value = `${new Site({ sld: SLD.EUREKA }).href}/results/#/standard?playbook=${playbook}&qid=${qid}`
}

const task = paperListIns.value.loadInitialData({
    ...basicParams.value,
})

watch(() => checkedChild.value, () => {
    hookErrorCode(task, LIMITED_PERMISSION_CODE, () => {
        updateLimitInfo(true)
    })
}, {
    immediate: true,
})
/**
 * 防止basic请求还没结束，就开始请求queryItemToShort
 */
watch(() => companyInfo.value?.name, () => {
    if (!companyInfo.value?.name) return
    generateQId(companyInfo.value?.name)
}, {
    immediate: true,
})

</script>
